import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { ReturnLossMutationKeys } from '../../../keys'
import {
	CreateReturnLossRequest,
	CreateReturnLossResponse,
} from '../../../type'
import { createReturnLoss } from '../../services'

interface CreateReturnLossParams {
	payload: CreateReturnLossRequest
}

export default function useMutationCreateReturnLoss(
	props?: UseBaseMutationOptions<
		CreateReturnLossResponse,
		CreateReturnLossParams
	>,
) {
	return useMutation({
		mutationKey: [ReturnLossMutationKeys.CreateReturnLoss],
		mutationFn: (params) => createReturnLoss(params.payload),
		...props,
	})
}
